import React from "react";
import PropTypes from "prop-types";

import { colorsDef } from "../utilities/colors";
import { textProps, textClass } from "../utilities/text";
import { colorsProps, colorsClass } from "../utilities/colors";
import { sizingProps, sizingClass } from "../utilities/sizing";
import { spacingProps, spacingClass } from "../utilities/spacing";
import { flexProps, flexClass } from "../utilities/flex";

import cn from "classnames";

const Button = (props) => {
  let {
    tag: Tag,
    className,
    children,
    onClick,
    size,
    block,
    outline,
    tooltip,
    disabled,
    ...attributes
  } = props;

  let colors, sizing, spacing, text, flex;
  [text, attributes] = textClass(attributes);
  [colors, attributes] = colorsClass(attributes);
  [sizing, attributes] = sizingClass(attributes);
  [spacing, attributes] = spacingClass(attributes);
  [flex, attributes] = flexClass(attributes);

  size = size ? `btn-${size}` : "";
  block = block ? `btn-${block}` : "";

  return (
    <Tag
      {...attributes}
      className={cn(
        "btn",
        flex,
        text,
        size,
        block,
        sizing,
        spacing,
        disabled && "disabled",
        colors,
        outline && `btn-outline-${outline}`,
        className
      )}
      onClick={onClick}
    >
      {children}
    </Tag>
  );
};

Button.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["sm", "lg"]),
  color: PropTypes.oneOf([...colorsDef]),
  block: PropTypes.bool,
  outline: PropTypes.oneOf([...colorsDef]),
  disabled: PropTypes.bool,
  ...textProps(),
  ...sizingProps(),
  ...colorsProps(),
  ...spacingProps(),
  ...flexProps(),
};
Button.defaultProps = {
  tag: "button",
  className: "",
};

export default Button;
